module.exports = __webpack_public_path__ + "img/b1.491d4143.png";